import React from "react";
import { MdArrowDownward, MdMenu } from "react-icons/md";
import { scroller } from "react-scroll";
import { Button, Nav, NavbarBrand, NavItem } from "reactstrap";
import supportsWebP from "supports-webp";
import { NavbarWithHeight } from "../NavbarWithHeight";

const NavbarTop = ({ toggle }: { toggle: () => void }) => {
  const [width, setWidth] = React.useState(0);

  React.useEffect(() => {
    const setWidthFunc = () => setWidth(window.innerWidth);
    window.addEventListener("resize", setWidthFunc);
    return () => window.removeEventListener("resize", setWidthFunc);
  }, []);

  const scrollToSecondHeader = () => {
    scroller.scrollTo("header2", { duration: 500, smooth: true });
  };
  const logo = supportsWebP
    ? require("../../../images/logo-192.webp")
    : require("../../../images/logo-192.png");

  return (
    <NavbarWithHeight color="dark" dark={true}>
      <NavbarBrand
        href="#"
        style={{ fontSize: 4.5 + "vh", display: "inline-block" }}
      >
        {width > 500 && (
          <img
            src={logo}
            id="logoHeader"
            className="mb-2 mr-1"
            style={{ width: 5 + "vh", height: 5 + "vh" }}
            alt="Closing Time Logo"
          />
        )}
        ClosingTime
      </NavbarBrand>
      <Nav className="pull-right" style={{ display: "inline-block" }}>
        <NavItem style={{ display: "inline-block" }}>
          <Button
            className="navbar-toggler"
            onClick={scrollToSecondHeader}
            href="#"
            id="downArrow"
            role="button"
            aria-label="Scroll To Restaurant List"
          >
            <MdArrowDownward fontSize="4.5vh" color="white" />
          </Button>
        </NavItem>
        <NavItem style={{ display: "inline-block" }}>
          <Button
            className="navbar-toggler"
            type="button"
            onClick={toggle}
            aria-controls="navbarToggleExternalContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            role="button"
          >
            <MdMenu fontSize="4.5vh" color="white" />
          </Button>
        </NavItem>
      </Nav>
    </NavbarWithHeight>
  );
};

export default NavbarTop;
